module.exports = __webpack_public_path__ + "media/promo/courses/images/format-dec-8c23156dc5175b0e44aeec66a157c899.png";